<template>
	<div>
		<el-card class="box-card">
			<div style="margin-bottom: 20px;">
				<el-form ref="queryForm" :model="queryParams" label-width="80px" inline size="small">
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="queryParams.distributorId" placeholder="请选择" clearable filterable
							style="width: 150px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单号:">
						<el-input :clearable=true v-model="queryParams.srcTradNo" placeholder="请输入订单号"
							style="width: 180px;" />
					</el-form-item>
					<el-form-item label="支付渠道:">
						<el-select v-model="queryParams.payChannel" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in payChannelOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="处理状态:">
						<el-select v-model="queryParams.resolved" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in resolvedOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间:">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleQuery">查询</el-button>
						<el-button @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<el-table :data="recordList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" v-loading="loading">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="订单号" prop="srcTradNo" width="200px"></el-table-column>
				<el-table-column label="退款单号" prop="refundNo" width="200px"></el-table-column>
				<el-table-column label="运营商" prop="distributorId" width="120px">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="支付渠道" prop="payChannel" width="100px">
					<template slot-scope="scope">
						<el-tag :type="scope.row.payChannel === 2 ? 'warning' : 'success'" size="small">
							{{ scope.row.payChannel === 2 ? '银联' : '微信' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="订单金额" prop="totalAmount" width="100px">
					<template slot-scope="scope">
						<span style="color: #67C23A; font-weight: bold;">¥{{ scope.row.totalAmount }}</span>
					</template>
				</el-table-column>
				<el-table-column label="退款金额" prop="refundAmount" width="100px">
					<template slot-scope="scope">
						<span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.refundAmount }}</span>
					</template>
				</el-table-column>
				<el-table-column label="错误码" prop="errCode" width="120px">
					<template slot-scope="scope">
						<el-tag type="danger" size="small">{{ scope.row.errCode }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="错误信息" prop="errMessage" min-width="200px">
				<template slot-scope="scope">
					<span class="err-msg-cell" style="color: #F56C6C;" @click="showErrDetail(scope.row.errMessage)">{{ scope.row.errMessage }}</span>
				</template>
			</el-table-column>
				<el-table-column label="退款前状态" prop="originalStatus" width="100px">
					<template slot-scope="scope">
						{{ getOriginalStatusDesc(scope.row.originalStatus) }}
					</template>
				</el-table-column>
				<el-table-column label="重试次数" prop="retryCount" width="80px"></el-table-column>
				<el-table-column label="处理状态" prop="resolved" width="100px">
					<template slot-scope="scope">
						<el-tag :type="scope.row.resolved === 1 ? 'success' : 'danger'" size="small">
							{{ scope.row.resolved === 1 ? '已处理' : '未处理' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="150px"></el-table-column>
				<el-table-column label="处理时间" prop="resolveTime" width="150px"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="150px" label="操作">
					<template slot-scope="scope">
						<el-button v-if="scope.row.resolved === 0" size="mini" type="success"
							@click="handleResolve(scope.row)">标记已处理</el-button>
						<el-button v-else size="mini" type="info" disabled>已处理</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>

			<el-dialog title="标记已处理" :visible.sync="resolveDialogVisible" width="450px">
				<el-form :model="resolveForm" label-width="80px">
					<el-form-item label="订单号:">
						<span>{{ resolveForm.srcTradNo }}</span>
					</el-form-item>
					<el-form-item label="错误信息:">
						<span class="err-msg-detail" style="color: #F56C6C;" @click="showErrDetail(resolveForm.errMessage)">{{ resolveForm.errMessage }}</span>
					</el-form-item>
					<el-form-item label="处理备注:">
						<el-input v-model="resolveForm.resolveRemark" type="textarea" :rows="3"
							placeholder="请输入处理备注（可选）"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="resolveDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirmResolve">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 错误信息详情弹框 -->
			<el-dialog title="错误信息详情" :visible.sync="errDialogVisible" width="700px" append-to-body>
				<div class="err-detail-body">
					<el-input type="textarea" :value="errDialogContent" :rows="12" readonly
						resize="none"></el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="copyErrContent">复 制</el-button>
					<el-button @click="errDialogVisible = false">关 闭</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			isAdmin: false,
			loading: false,
			dateRange: [],
			distributorOptions: [],
			distributorInfoList: [],
			payChannelOptions: [
				{ key: 1, value: '微信支付' },
				{ key: 2, value: '银联支付' }
			],
			resolvedOptions: [
				{ key: 0, value: '未处理' },
				{ key: 1, value: '已处理' }
			],
			queryParams: {
				page: 1,
				limit: 8,
				srcTradNo: '',
				distributorId: '',
				payChannel: null,
				resolved: null,
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			},
			recordList: [],
			total: 0,
			resolveDialogVisible: false,
			resolveForm: {
				id: '',
				srcTradNo: '',
				errMessage: '',
				resolveRemark: ''
			},
			errDialogVisible: false,
			errDialogContent: ''
		}
	},
	created() {
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.getDistributorOptions();
		this.queryParams.queryDistributorId = getCurrentDistributorId();
		this.getList();
		this.$root.$on('distributorChanged', this.handleDistributorChange);
	},
	beforeDestroy() {
		this.$root.$off('distributorChanged', this.handleDistributorChange);
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.queryParams.queryDistributorId = distributorId || '';
			this.queryParams.page = 1;
			this.getList();
		},
		async getList() {
			this.loading = true;
			try {
				const { data: res } = await this.$http.post(
					'/member/refundFailRecord/getPageInfo', this.queryParams);
				if (res.code != 200) {
					this.$message.error(res.msg);
					return;
				}
				this.recordList = res.data.list;
				this.total = res.data.total;
			} catch (e) {
				this.$message.error('获取数据失败');
			} finally {
				this.loading = false;
			}
		},
		handleQuery() {
			this.queryParams.page = 1;
			this.getList();
		},
		resetQuery() {
			this.dateRange = [];
			this.queryParams = {
				page: 1,
				limit: this.queryParams.limit,
				srcTradNo: '',
				distributorId: '',
				payChannel: null,
				resolved: null,
				startDate: '',
				endDate: '',
				queryDistributorId: this.queryParams.queryDistributorId
			};
			this.getList();
		},
		handleDateChange(val) {
			if (val) {
				this.queryParams.startDate = val[0];
				this.queryParams.endDate = val[1];
			} else {
				this.queryParams.startDate = '';
				this.queryParams.endDate = '';
			}
		},
		handleSizeChange(pageSize) {
			this.queryParams.limit = pageSize;
			this.getList();
		},
		handleCurrentChange(pageNum) {
			this.queryParams.page = pageNum;
			this.getList();
		},
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				this.distributorInfoList = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let list = res.data.data;
				for (let index in list) {
					this.distributorOptions.push({ key: list[index].id, value: list[index].name });
				}
				this.distributorInfoList = list;
			});
		},
		getDistributorName(distributorId) {
			if (!distributorId) return '未知';
			const d = this.distributorInfoList.find(item => item.id === distributorId);
			return d ? d.name : '未知';
		},
		getOriginalStatusDesc(status) {
			switch (status) {
				case 0: return '已退款';
				case 1: return '未退款';
				case 2: return '已消费';
				case 3: return '消费已退款';
				case 4: return '消费未退款';
				case 5: return '执行退款中';
				default: return '未知';
			}
		},
		handleResolve(row) {
			this.resolveForm = {
				id: row.id,
				srcTradNo: row.srcTradNo,
				errMessage: row.errMessage,
				resolveRemark: ''
			};
			this.resolveDialogVisible = true;
		},
		confirmResolve() {
			this.$confirm('确认将该记录标记为已处理吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/member/refundFailRecord/resolve', null, {
					params: {
						id: this.resolveForm.id,
						resolveRemark: this.resolveForm.resolveRemark
					}
				}).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.resolveDialogVisible = false;
					this.$message.success('处理成功');
					this.getList();
				});
			}).catch(() => {});
		},
		showErrDetail(msg) {
			if (!msg) return;
			this.errDialogContent = msg;
			this.errDialogVisible = true;
		},
		copyErrContent() {
			const text = this.errDialogContent;
			if (!text) return;
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('已复制到剪贴板');
				}).catch(() => {
					this.fallbackCopy(text);
				});
			} else {
				this.fallbackCopy(text);
			}
		},
		fallbackCopy(text) {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			try {
				document.execCommand('copy');
				this.$message.success('已复制到剪贴板');
			} catch (e) {
				this.$message.warning('复制失败，请手动选择文本复制');
			}
			document.body.removeChild(ta);
		}
	}
}
</script>

<style scoped>
.el-card {
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.el-table {
	margin-top: 15px;
	font-size: 12px;
}

.el-pagination {
	margin-top: 15px;
}

/* 错误信息单元格：单行省略 + 可点击 */
.err-msg-cell {
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: middle;
	cursor: pointer;
	border-bottom: 1px dashed #F56C6C;
}

.err-msg-cell:hover {
	background-color: #fef0f0;
}

/* 标记已处理弹框里的错误信息也支持点击查看完整内容 */
.err-msg-detail {
	cursor: pointer;
	border-bottom: 1px dashed #F56C6C;
}

.err-detail-body /deep/ .el-textarea__inner {
	font-family: Consolas, Monaco, "Courier New", monospace;
	font-size: 12px;
	line-height: 1.6;
	background-color: #fafafa;
	color: #F56C6C;
}
</style>
